import React, { FC } from "react";
import styled from "styled-components";
import { InternalLink } from "./../../link/InternalLink";

const Header = styled.div`
  background-color: ${({ theme }) =>
    theme.header?.simple?.backgroundColor || theme.color.primary};
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  height: 50px;
  width: 180px;
  object-fit: contain;
`;

export const SimpleHeader: FC<{
  fallbackUrl: string | null;
  logo: { src: string; alt: string | null } | null;
}> = ({ fallbackUrl, logo }) => {
  if (
    typeof window !== "undefined" &&
    window.navigator.userAgent.includes("GxApp")
  ) {
    return null;
  }

  return (
    <Header>
      <InternalLink href={fallbackUrl || ""} center>
        <Image alt={logo?.alt || ""} src={logo?.src || ""} />
      </InternalLink>
    </Header>
  );
};
